import { buildQuery } from './ypQueryBuilder';
import { inQueryLanguageDateFormat } from './dateTimeUtilities';

export const getDefaultFilterName = () => i18n('New Filter');

export const createEmptyEventsFilter = () => ({
  name: getDefaultFilterName(),
  isDefault: false,
  locations: [],
  statuses: [],
  profiles: []
});

export const createNoFilter = () => ({
  ...createEmptyEventsFilter(),
  name: i18n('No Filter'),
  id: -1
});

export const setFilterAsDefault = (filter) => {
  filter.isDefault = true;
};

export const getDefaultFilter = (filters) => {
  const defaultFilter = filters.find((filter) => filter.isDefault);
  if (!defaultFilter) return createNoFilter();
  return defaultFilter;
};

export const isNoFilter = (filter) => filter.id && filter.id === -1;

export const addNoFilterToCollection = (collection) => {
  /* Do not add the no filter twice */
  if (collection.length > 0 && !isNoFilter(collection[0]))
    return [createNoFilter(), ...collection];
  return collection;
};

const createKeywordToOptionsMapping = (
  dateObject,
  selectedFilter,
  eventsFilterOptions
) => ({
  date: {
    filterOn: [inQueryLanguageDateFormat(dateObject)]
  },
  location: {
    filterOn: selectedFilter.locations,
    all: eventsFilterOptions ? eventsFilterOptions.locations : []
  },
  profile: {
    filterOn: selectedFilter.profiles,
    all: eventsFilterOptions ? eventsFilterOptions.profiles : []
  },
  status: {
    filterOn: selectedFilter.statuses,
    all: eventsFilterOptions ? eventsFilterOptions.statuses : []
  }
});

export const convertFilterToYPQuery = (dateObject, selectedFilter, eventsFilterOptions) =>
  buildQuery(
    null,
    createKeywordToOptionsMapping(dateObject, selectedFilter, eventsFilterOptions)
  );

/* Returns the id of the first location */
const eventLocationId = (ypEvent) => {
  const { locations } = ypEvent;
  return locations && locations.length > 0 ? locations[0].id : null;
};

const eventStatusId = (ypEvent) => {
  const { status } = ypEvent;
  return status && status.id ? status.id : null;
};

const eventProfileId = (ypEvent) => {
  const { profile } = ypEvent;
  return profile && profile.id ? profile.id : null;
};

export const postQueryResultFiltering = (
  events,
  dateObject,
  selectedFilter,
  eventsFilterOptions
) => {
  const mapping = createKeywordToOptionsMapping(
    dateObject,
    selectedFilter,
    eventsFilterOptions
  );
  return events.filter(
    (event) =>
      (mapping.location.filterOn.length > 0
        ? mapping.location.filterOn.includes(eventLocationId(event))
        : true) &&
      (mapping.profile.filterOn.length > 0
        ? mapping.profile.filterOn.includes(eventProfileId(event))
        : true) &&
      (mapping.status.filterOn.length > 0
        ? mapping.status.filterOn.includes(eventStatusId(event))
        : true)
  );
};
